import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { FormService } from 'app/services/form.service';

@Component({
  selector: 'app-polymer-presence-disclosure',
  templateUrl: './polymer-presence-disclosure.component.html',
  styleUrls: ['./polymer-presence-disclosure.component.scss']
})
export class PolymerPresenceDisclosureComponent implements OnInit {
  @ViewChild('polymerPresenceDisclosureInput') polymerPresenceDisclosureInput!: ElementRef;
  polymerPresenceDisclosure!: string;

  constructor(private formService: FormService) {}
  
  ngOnInit(): void {
    this.polymerPresenceDisclosure = this.currentForm.get('polymerPresenceDisclosure')?.value;
  }

  public clearPolymerPresenceDisclosureInputField() {
    this.polymerPresenceDisclosure = '';
    this.currentForm.patchValue({'polymerPresenceDisclosure': ''});
  }

  public updatePolymerPresenceDisclosure(event: Event) {
    if(event && event.type === 'blur') {
      var target = document.activeElement;
      if(target && target.nodeValue === "cancel") {
        this.polymerPresenceDisclosure = '';
      }
    }
    this.currentForm.patchValue({'polymerPresenceDisclosure': this.polymerPresenceDisclosure});
  }

  public cancelUpdate() {
    this.polymerPresenceDisclosure = this.currentForm.get('polymerPresenceDisclosure')?.value;
  }

  get currentForm(): FormGroup {
    return this.formService.getCurrentUsanFormValue();
  }

}
